/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_PAYMENT_NAME(state, data) {
    state.paymentName = data;
  },

  SET_ALL_PAYMENT_KINDS_AND_TYPES(state, data) {
    state.paymentKindsAndTypes = data;
  },

  ADD_NEW_CREATED_PAYMENT(state, data) {
    state.paymentName.unshift(data);
  },

  UPDATE_PAYMENT_NAME(state, data) {
    const index = state.paymentName.findIndex(element => element.idInDB === data.idInDB);
    state.paymentName[index] = data;
  }
};
